export const LicenseRequestStatuses = {
  ENQUEUED: "ENQUEUED",
  STARTED: "STARTED",
  SUBMITTED: "SUBMITTED",
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  APPROVED: "APPROVED",
  DENIED: "DENIED",
  DELETED: "DELETED",
  EXPIRED: "EXPIRED",
  UPDATE_NEEDED: "UPDATE_NEEDED",
  UPDATE_MADE: "UPDATE_MADE",
  VOIDED: "VOIDED",
};
